import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const { setToken } = useAuth();
  const navigate = useNavigate();

  const BASE_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const url = isLogin
      ? `${BASE_URL}/api/users/login`
      : `${BASE_URL}/api/users/signup`;

    const payload = isLogin
      ? { email, password }
      : { name: username, email, password, role: "user" };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok)
        return toast.error(data.error || "Something went wrong");

      if (!isLogin) {
        toast.success("Signup successful! Please log in.");
        setIsLogin(true);
        setUsername("");
        setPassword("");
        setEmail("");
        return;
      }

      // On login
      sessionStorage.setItem("token", data.token);
      setToken(data.token);
      toast.success("Login successful!");
      setTimeout(() => navigate("/"), 500);
    } catch (err) {
      toast.error("Server error. Try again later.");
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <h3>{isLogin ? "Login" : "Sign Up"}</h3>
        <p>{isLogin ? "Enter your email and password to access your account":"Enter your information to create a new account"}</p>

        {!isLogin && (
          <>
          <label >Username</label>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
            required
          />
          </>
        )}
        <label >Email</label>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
          required
        />

         <label htmlFor="email">Password</label>
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          required
        />

        <button type="submit" style={styles.button}>
          {isLogin ? "Login" : "Sign Up"}
        </button>

        <p style={styles.toggleText}>
          {isLogin ? "Don't have an account?" : "Already have an account?"}{" "}
          <span onClick={() => setIsLogin(!isLogin)} style={styles.toggleLink}>
            {isLogin ? "Sign Up" : "Login"}
          </span>
        </p>
      </form>
    </div>
  );
}const styles = {
  container: {
    height: "100vh",
    background: "linear-gradient(135deg , #f5665c, #ffebee)", // Updated gradient
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  form: {
    backgroundColor: "#fff",
    padding: "20px 35px 50px",
    borderRadius: "10px",
    width: "100%",
    maxWidth: "400px",
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.15)",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  title: {
    textAlign: "center",
    marginBottom: "10px",
    color: "#f44336", // deeper red for headings
    fontSize: "24px",
    fontWeight: "600",
  },
  input: {
    padding: "12px 14px",
    fontSize: "15px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    outline: "none",
    transition: "all 0.2s",
  },
  inputFocus: {
    borderColor: "#f5665c",
    boxShadow: "0 0 0 2px rgba(245, 102, 92, 0.2)",
  },
  label: {
    fontSize: "14px",
    color: "#444",
    marginBottom: "4px",
    marginTop: "6px",
    fontWeight: "500",
  },
  button: {
    marginTop: "10px",
    padding: "12px",
    fontSize: "16px",
    backgroundColor: "#f5665c", // button color
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "500",
    transition: "background 0.3s",
  },
  buttonHover: {
    backgroundColor: "#e53935",
  },
  toggleText: {
    fontSize: "14px",
    textAlign: "center",
    marginTop: "16px",
    color: "#666",
  },
  toggleLink: {
    color: "#f44336", // red tone link
    cursor: "pointer",
    textDecoration: "underline",
    marginLeft: "5px",
    fontWeight: "500",
  },
};
